<div class="inactive-link-page">
  <app-secondary-logo />

  <div class="inactive-link-page__container">
    <div class="inactive-link-page__content">
      <div class="inactive-link-page__wrapper">
        <div class="inactive-link-page__header">
          <h2 class="inactive-link-page__title">
            {{ 'inactiveLinkPage.title' | translate }}
          </h2>
          <p class="inactive-link-page__description">
            {{ 'inactiveLinkPage.text' | translate }}
          </p>
        </div>
        <button class="inactive-link-page__back-to-login-btn" (click)="returnToLogin()">
          {{ 'inactiveLinkPage.button' | translate }}
        </button>
      </div>
    </div>

    <div class="inactive-link-page__banner">
      <img ngSrc="/assets/images/mail-dynamic.png" alt="Mail" height="480" width="480" />
    </div>
  </div>
</div>
